var keys = {
    FAQ_q_1: "FAQ_q_1",
    FAQ_a_1: "FAQ_a_1",
    FAQ_q_2: "FAQ_q_2",
    FAQ_a_2: "FAQ_a_2",
    FAQ_q_3: "FAQ_q_3",
    FAQ_a_3: "FAQ_a_3",
    FAQ_q_4: "FAQ_q_4",
    FAQ_a_4: "FAQ_a_4",
    FAQ_q_5: "FAQ_q_5",
    FAQ_a_5: "FAQ_a_5",
    FAQ_q_6: "FAQ_q_6",
    FAQ_a_6: "FAQ_a_6",
    FAQ_q_7: "FAQ_q_7",
    FAQ_a_7: "FAQ_a_7",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImtleXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTSxJQUFJLEdBQTRCO0lBQ3BDLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0NBQ25CLENBQUM7QUFFRixlQUFlLElBQUksQ0FBQyJ9